import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Always fetch fresh data
      gcTime: 1000 * 60 * 5, // 5 minutes cache
      retry: 3, // Retry failed queries 3 times
      refetchOnWindowFocus: true, // Refetch when window regains focus
      refetchOnReconnect: true, // Refetch on reconnect
      refetchOnMount: true, // Always refetch on mount
    },
    mutations: {
      retry: 1, // Retry mutations once
    },
  },
});
